import React, { useRef } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {v4 as uuidv4} from 'uuid';
import { postImage } from "./../../utilities/datalayer";

export const ImagePreview = ({ dataUri, cancelPhoto, imageproperties, saveImages }) => {
    const fileInputRef = useRef(null);

    const handleCancel = () => {
        cancelPhoto();
    }

    const uploadImage = async () => {
        let filename = imageproperties.storeId + "-" + imageproperties.questionId + "-" + uuidv4() +".jpg";
        await postImage(dataUri, filename, imageproperties.questionId).then((response) => {
            if (response === 200) {
                saveImages(filename);
                handleCancel();
            }
        });
    }

    const handleBrowseClick = () => {
        fileInputRef.current.click();
    }

    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const fileDataUri = e.target.result;
                // Update the dataUri state in the parent component
                // We need to pass this up to the Camera component
                if (imageproperties.onFileSelect) {
                    imageproperties.onFileSelect(fileDataUri);
                }
            };
            reader.readAsDataURL(file);
        }
    }

    return (
        <Box className="demo-image-preview">
            <img src={dataUri} />
            <Box>
                <Button variant="text" sx={{ mt: 6, mr: 6 }} onClick={handleCancel}>CANCEL</Button>
                <Button variant="contained" sx={{ mt: 6, mr: 2 }} onClick={uploadImage}>SAVE</Button>
                <Button variant="outlined" sx={{ mt: 6 }} onClick={handleBrowseClick}>BROWSE</Button>
            </Box>
            <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                onChange={handleFileSelect}
            />
            <Typography variant="subtitle2" sx={{ mt: 6 }}>Note: Clicking 'Save' will upload this file to the server.</Typography>
        </Box>
    );
};


export default ImagePreview;